module.exports = __webpack_public_path__ + "img/hr-cargo-wagon-shadow-3.e326f96a.png";